<template>
  <WizardModal
    modal-id="wizard-camera-modal"
    :is-active="true"
    :is-add="isAdd"
    :wizard-title="wizardTitle"
    :steps="wizardSteps"
    :step-icons="wizardStepIcons"
    :finishAtStep="finishAtStep"
    :current-step="currentStep"
    :show-previous-button="true"
    :show-save-button="false"
    :show-next-button="showNextButton"
    :show-finish-button="showFinishButton"
    :activate-btn-save="true"
    :loading="isLoading"
    @close-wizard="closeWizard"
    @prev-step="prevStep"
    @next-step="nextStep"
    @on-submit="nextStep"
    >
    <template #step-0="{ currentStep, loading }" v-if="wizardKey !== 0 || isAdd">
      <information-step
        ref="infoStep"
        :item-edit="itemEdit"
        :device-info="deviceInfo"
        :is-device-info-loading="isDeviceInfoLoading"
        :show-no-data-message="showNoDataMessage"
        :type-options="typeOptions"
      />
    </template>
    <template #step-1="{ currentStep, loading }">
      <location-step
        ref="locationStep"
        :item-edit="itemEdit"
        :center-options="centerOptions"
        :sector-options="sectorOptions"
        :unit-options="unitOptions"
      />
    </template>
    <template #step-2="{ currentStep, loading }">
      <transmition-step
        ref="streamStep"
        :item-edit="itemEdit"
        @update:itemData="onUpdateTransmitionStep"
      />
    </template>
  </WizardModal>
</template>

<script>
import { computed,onMounted,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import InformationStep from "./InformationStep.vue";
import LocationStep from "./LocationStep.vue";
import TransmitionStep from "./TransmitionStep.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import WizardModal from "@/components/WizardModal/Index.vue";
import store from "@/store";
import { useDeviceInfo } from "../useDeviceInfo";

export default {
  components: {
    InformationStep,
    LocationStep,
    TransmitionStep,
    WizardModal
  },
  props: {
    centerOptions: {
      type: Array,
      default: []
    },
    dvrOptions: {
      type: Array,
      default: []
    },
    resellerOptions: {
      type: Array,
      default: []
    },
    sectorOptions: {
      type: Array,
      default: []
    },
    typeOptions: {
      type: Array,
      default: []
    },
    unitOptions: {
      type: Array,
      default: []
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    itemEdit: {
      type: Object
    }
  },
  setup (props, { emit }) {
    //HOOKS
    onMounted(async () => getDeviceInfo());

    //COMPOSABLES
    const { getDeviceInfo, deviceInfo, isDeviceInfoLoading, showNoDataMessage } = useDeviceInfo(props.itemEdit);

    const toast = useToast();

    //DATA
    const cameras = ref([]);

    const currentStep = ref(0);

    const refExtraInfo = ref(null);

    const finishAtStep = ref(2);

    const infoStepRef = ref(null);

    const locationStepRef = ref(null);

    const streamStepRef = ref(null);

    const isBusy = ref(false);

    const isLoading = ref(false);

    const isWizardActive = ref(false);

    const refDiscoverCameras = ref(null);

    const wizardKey = ref(0);
    const transmitionConfig = ref(null);

    const wizardTitle = ref('Cámaras Wizard');

    const wizardSteps = ref(['Información', 'Ubicación','Transmisión']);

    const wizardStepIcons = ref(['ToolIcon', 'MapIcon', 'MonitorIcon']);

    //COMPUTED
    const showFinishButton = computed(() => (props.isAdd && currentStep.value === 1) || (props.isAdd && (currentStep.value === finishAtStep.value)));

    const showNextButton = computed(() => (currentStep.value < finishAtStep.value));

    //METHODS
    const closeWizard = () => {
      currentStep.value = 0;

      emit('close-wizard');
    }
    const onUpdateTransmitionStep = (config) => {
      transmitionConfig.value = config
    }

    const saveTransmitionConfig = () => {
      const req = {
        "live_profile": transmitionConfig.value.live_profile,
        "recording_profile": transmitionConfig.value.recording_profile,
        "transmission": transmitionConfig.value.transmission.value ?? transmitionConfig.value.transmission,
        "video_encoder": transmitionConfig.value.video_encoder,
        "resolution": transmitionConfig.value.resolution,
        "frame_rate": transmitionConfig.value.frame_rate,
        "bitrate": transmitionConfig.value.bitrate,
        "vbr": transmitionConfig.value.vbr
      }
      store.dispatch("hanwha_camera/saveTransmitionConfig", {id: props.itemEdit.device.id ,params:req})
    }

    const nextStep = async () => {
      let isValid = true;

      try {
        if (currentStep.value === 0 && infoStepRef.value?.validateStep) {
          isValid = await infoStepRef.value.validateStep();
        } else if (currentStep.value === 1 && locationStepRef.value?.validateStep) {
          isValid = await locationStepRef.value.validateStep();
        } else if (currentStep.value === 2 && streamStepRef.value?.validateStep) {
          isValid = await streamStepRef.value.validateStep();
        }

        if (isValid) {
          if (currentStep.value === finishAtStep.value) {
            onSubmit();
            return
          }

          currentStep.value++;
        }
      } catch (error) {
        console.error("Error during step validation:", error);
      }
    }

    const prevStep = () => {
      if (currentStep.value > 0) {
        currentStep.value--;
      }
    }

    const onSubmit = () => {
      let dispatch;
      const req = {
        id: props.itemEdit.id,
        params: {
          id_unit:
            props.itemEdit.id_unit.length > 0
              ? props.itemEdit.id_unit.map((unit) => unit.value)
              : null,
          id_center: props.itemEdit.id_center || null,
          id_sector: props.itemEdit.id_sector || null,
          id_reseller: props.itemEdit.id_reseller || null,
          id_type: props.itemEdit.id_type,
          delayed_record_minutes: props.itemEdit.delayed_record_minutes,
          forward_record_minutes: props.itemEdit.forward_record_minutes,
          id_device_tag: props.itemEdit.id_device_tag,
          rtsp_available: props.itemEdit.rtsp_available,
          name: props.itemEdit.name,
          username: props.itemEdit.username,
          password: props.itemEdit.password,
          webviewer_url: props.itemEdit.webviewer_url,
          is_fisheye: props.itemEdit.is_fisheye,
          send_to_seproban: props.itemEdit.send_to_seproban,
          timezone: props.itemEdit.timezone,
          live_profile: props.itemEdit.live_profile,
          recording_profile: props.itemEdit.recording_profile,
          remote_profile: props.itemEdit.remote_profile
        },
      };

      //saveTransmitionConfig();
      dispatch = store.dispatch("hanwha_camera/edit", req);

      dispatch
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            emit("refresh");
            emit("close-wizard");
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      cameras,
      currentStep,
      finishAtStep,
      isBusy,
      isLoading,
      isWizardActive,
      infoStepRef,
      locationStepRef,
      streamStepRef,
      refDiscoverCameras,
      refExtraInfo,
      wizardKey,
      wizardTitle,
      wizardSteps,
      wizardStepIcons,
      getDeviceInfo,
      deviceInfo,
      isDeviceInfoLoading,
      showNoDataMessage,

      showFinishButton,
      showNextButton,

      closeWizard,
      prevStep,
      nextStep,
      onSubmit,
      onUpdateTransmitionStep
    }
  }
}
</script>
